module.exports = "<nav>\n  <a [routerLink]=\"['/']\" [routerLinkActive]=\"['router-link-active']\" [routerLinkActiveOptions]=\"{exact:true}\">HOME</a>\n  <a [routerLink]=\"['/about']\" [routerLinkActive]=\"['router-link-active']\" [routerLinkActiveOptions]=\"{exact:true}\">ABOUT</a>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/navbar/navbar.component.html
// module id = ../../../../../src/app/shared/navbar/navbar.component.html
// module chunks = main